"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SpotifyIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.14 6.206c-2.256-1.34-5.978-1.464-8.132-.81a.654.654 0 11-.38-1.253c2.473-.75 6.583-.605 9.181.937a.655.655 0 01-.668 1.126zm-.073 1.984a.546.546 0 01-.75.18C8.434 7.214 5.566 6.88 3.34 7.554a.547.547 0 01-.317-1.044c2.542-.771 5.703-.398 7.863.93a.546.546 0 01.18.75zm-.857 1.906a.435.435 0 01-.6.146C7.967 9.237 5.898 9.01 3.46 9.567a.436.436 0 11-.193-.85c2.666-.61 4.953-.348 6.799.78a.437.437 0 01.144.6zM7 0a7 7 0 100 14A7 7 0 007 0"
  })))
});
SpotifyIcon.displayName = 'SpotifyIcon';
var _default = exports.default = SpotifyIcon;